import { render } from "./DetailInfo.vue?vue&type=template&id=69218672&scoped=true"
import script from "./DetailInfo.vue?vue&type=script&lang=ts"
export * from "./DetailInfo.vue?vue&type=script&lang=ts"

import "./DetailInfo.vue?vue&type=style&index=0&id=69218672&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69218672"

export default script